<form [formGroup]="form" (ngSubmit)="submit()">

    @if (redirectionToSubscriptionViewEnabled) {

        <div class="ligne_form">

            <div class="row marges ligne_form">

                <div class="col x_end">

                    <!-- Retour à mon abonnement -->

                    <button class="btn_cta btn_little" type="button" (click)="redirectToList()">
                        {{ 'subscription.own.back.value' | translate }}
                    </button>
                </div>

            </div>

        </div>
    }

    <div class="ligne_form">

        <div class="row marges ligne_form">

            <!-- Traitement en cours -->

            @if(isDisabled && hasWaitingProcess) {

                @if(!hasWaitingPayment) {

                    <!-- Abonnement sans paiement en cours de traitement -->

                    <div class="paymentWaiting">
                        {{ 'subscription.process_waiting.value' | translate}}
                    </div>
                }

                @if(hasWaitingPayment) {

                    <!-- Abonnement avec paiement en cours de traitement -->

                    <div class="paymentWaiting">
                        {{ 'subscription.payment_waiting.value' | translate}}
                    </div>
                }
            }

            <!-- Demande de downgrade en cours de traitement -->

            @if(isDisabled && hasWaitingDowngrade) {

                <div class="paymentWaiting">

                    @if(waitingSocietySubscription.subscription.tag === 'starter') {

                        {{'subscription.downgrade_waiting.fromPremiumToStarter.value' | translate : {date: dateNextInvoice | date : 'shortDate' : null : localeId}  }}<br/><br/>

                        {{ 'subscription.downgrade_waiting.description.value' | translate}}

                        <br/>

                        <ul style="margin-top: 18px">
                            <li>{{'subscription.pack.starter.value' | translate }}</li>
                        </ul>

                        <br/><br/>

                        <div class="ck-content" [innerHTML]="'subscription.downgrade_waiting.fromPremiumToStarter.info.value'| translate"></div>
                    }

                    @if(waitingSocietySubscription.subscription.tag === 'premium') {

                        {{'subscription.downgrade_waiting.value' | translate : {date: dateNextInvoice | date : 'shortDate' : null : localeId}  }}<br/><br/>

                        {{ 'subscription.downgrade_waiting.description.value' | translate}}

                        <br/>

                        <ul style="margin-top: 18px">
                            @for(subscription of data; track subscription) {
                                @if(subscription.paymentStatus === 2) {

                                    <li>
                                        @if(subscription.subscription.isUnlimitedMaxOffer) {
                                            {{ 'subscription.unlimited.title.value' | translate }}
                                        }
                                        @if(!subscription.subscription.isUnlimitedMaxOffer) {
                                            {{'form.user.subscription.fields.subscription.group.value' | translate :{'nbOffer': subscription.subscription.maxOffer} }}
                                        }
                                    </li>
                                }
                            }
                        </ul>

                        <br/><br/>

                        <div [innerHTML]="'subscription.downgrade_waiting.info.value'| translate"></div>
                    }

                </div>
            }

            @if(!(isDisabled && (hasWaitingProcess))) {

                <div class="col_12">

                    @if(dateStartSubscription) {

                        <!-- Date de dernière mise à jour d'abonnement -->

                        <div class="form-group">
                            <p class="bold">{{ 'subscription.dateStart.value'  | translate }} :
                                <span>{{ dateStartSubscription  | date : 'shortDate' : null : localeId}}</span>
                            </p>
                        </div>
                    }

                    @if(dateNextInvoice) {

                        <!-- Date de prochaine échéance -->

                        <div class="form-group">
                            <p class="bold">{{ 'subscription.dateNextInvoice.value'  | translate }} :
                                <span>{{ dateNextInvoice  | date : 'shortDate' : null : localeId}}</span>
                            </p>
                        </div>
                    }

                    <!-- Périodicité -->

                    <div class="form-group">
                        <p class="bold">{{'form.user.subscription.fields.periodicity.title.value' | translate}}</p>
                    </div>

                    <div class="row marges licenceType_choice_tiles_row">

                        <div class="col_12 col_sm_6 col_md_6 col_lg_3 licenceType_choice_tile_wrapper" (click)="handlePeriodicitySelection('M')">

                            <div class="licenceType_choice_tile" [ngClass]="getPeriodicityClasses('M')">
                                <div class="tile_top">
                                    <span class="ty-check"></span>
                                    <p>{{ 'form.user.subscription.fields.periodicity.month.value' | translate }}</p>
                                </div>
                                <div class="tile_bottom">
                                    <p>{{ 'form.user.subscription.fields.periodicity.month.description.value' | translate }}</p>
                                </div>
                            </div>
                        </div>

                        <div class="col_12 col_sm_6 col_md_6 col_lg_3 licenceType_choice_tile_wrapper" (click)="handlePeriodicitySelection('Y')">

                            <div class="licenceType_choice_tile" [ngClass]="getPeriodicityClasses('Y')">
                                <div class="tile_top">
                                    <span class="ty-check"></span>
                                    <p>{{ 'form.user.subscription.fields.periodicity.year.value' | translate }}</p>
                                </div>
                                <div class="tile_bottom">
                                    <p>{{ 'form.user.subscription.fields.periodicity.year.description.value' | translate }}</p>
                                </div>
                            </div>
                        </div>

                        @if(form.get('periodicity').errors && (form.get('periodicity').dirty || form.get('periodicity').touched)) {

                            <mat-error>
                                <div class="invalid-feedback">
                                    @if(form.get('periodicity').errors.required) {
                                        <div>{{ 'form.control.error.required.value' | translate }}</div>
                                    }
                                </div>
                            </mat-error>
                        }

                    </div>

                    @if(form.get('periodicity').valid) {

                        <!-- Licence -->

                        <div class="form-group">
                            <p class="bold">{{'form.user.subscription.fields.subscription.title.value' | translate}}</p>
                        </div>

                        <div class="row marges ligne_form">
                            <div class="col_12">
                                <div class="form-group">
                                    <div class="checkbox">
                                        <input type="checkbox" class="keep-color" id="noLicence" [(ngModel)]="isSubscriptionWithoutOffer" [ngModelOptions]="{ standalone: true }" [disabled]="isDisabled" (ngModelChange)="handleSubscriptionWithoutOfferSelection()">
                                        <label for="noLicence">{{ 'form.user.subscription.fields.subscription.noSubcription.value' | translate }}</label>
                                    </div>
                                    <br/>
                                </div>
                            </div>
                        </div>

                        <div class="row marges licenceType_choice_tiles_row">

                            @for(subscription of availableSubscriptions; track subscription.id) {

                                <div class="col_12 col_sm_6 col_md_6 col_lg_3 licenceType_choice_tile_wrapper" (click)="handleSubscriptionSelection(subscription)">

                                    <div class="licenceType_choice_tile" [ngClass]="getSubscriptionClasses(subscription)">
                                        <div class="tile_top">
                                            <p>{{'form.user.subscription.fields.subscription.pack.value' | translate }}</p>
                                            @if(subscription.isUnlimitedMaxOffer) {
                                                <span class="number">{{'form.user.subscription.fields.subscription.unlimited.value' | translate }}</span>
                                            }
                                            @if(!subscription.isUnlimitedMaxOffer) {
                                                <span class="number">{{'form.user.subscription.fields.subscription.offer.value' | translate: {count: subscription.maxOffer} }}</span>
                                            }
                                        </div>
                                        <div class="tile_bottom">
                                            <div class="choice_item">
                                                <div class="price">
                                                    <span class="ty-check"></span>
                                                    @if(form.get('periodicity').value === 'M') {
                                                        <span class="frequency_price">{{ 'form.user.subscription.fields.subscription.price.month.value' | translate:{
                                                            'price': parsePrice(subscription.monthlyPrice),
                                                            'currency': '€'
                                                        } }}</span>
                                                    }
                                                    @if(form.get('periodicity').value === 'Y') {
                                                        <span class="frequency_price">{{ 'form.user.subscription.fields.subscription.price.year.value' | translate:{
                                                            'price': parsePrice(subscription.yearlyPrice),
                                                            'currency': '€'
                                                        } }}</span>
                                                    }
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            }

                        </div>

                        <!-- Message d'erreur si aucune licence n'est sélectionnée -->

                        @if((form.get('subscription').errors && (form.get('subscription').dirty || form.get('subscription').touched))) {
                            <mat-error class="form-group">
                                <div class="invalid-feedback">
                                    @if(form.get('subscription').errors.required) {
                                        <div>{{ 'form.user.subscription.fields.subscription.error.value' | translate }}</div>
                                    }
                                </div>
                            </mat-error>
                        }
                    }

                    @if(!isDisabled && summarySocietySubscription) {

                        <!-- Tarif de l'abonnement -->

                        <div class="form-group licenceType_choice_tiles_row">
                            <p class="total">{{ 'subscription.totalPrice.value' | translate}} :
                                <span>
                                    @if(form.get('periodicity').value === 'M') {
                                        {{ 'form.user.subscription.fields.subscription.totalPrice.month.value' | translate:{price: parsePrice(summarySocietySubscription.totalPrice), currency: '€'} }}
                                    }
                                    @if(form.get('periodicity').value === 'Y') {
                                        {{ 'form.user.subscription.fields.subscription.totalPrice.year.value' | translate:{price: parsePrice(summarySocietySubscription.totalPrice), currency: '€'} }}
                                    }
                                </span>
                            </p>
                        </div>
                    }

                    @if(hasPromotion && isDisabled) {

                        <!-- Promotion appliquée -->

                        <div class="form-group">
                            <p class="bold">
                                {{ 'payment.promo.value' | translate }} : <span>{{ formatPrice(promotion) }}</span>
                            </p>
                            <p>
                                {{ 'subscription.promotion.availableUntil' | translate }} : <span>{{ dateEndPromotion  | date : 'shortDate' : null : localeId}}</span>
                            </p>
                        </div>
                    }

                    @if(summarySocietySubscription && summarySocietySubscription.applyAdmission) {

                        <!-- Frais d'admission -->

                        <div class="form-group">
                            <p class="bold">{{ 'subscription.admissionPrice.value' | translate }} :
                                <span>{{ formatPrice(summarySocietySubscription.admissionPrice) }}</span>
                            </p>
                        </div>
                    }

                </div>
            }
        </div>
    </div>

    <!-- Informations relatives au downgrade d'un abonnement -->

    <div class="ligne_form row x_center">
        <div class="form-group">

            @if(isDowngrade && !isSubscriptionWithoutOfferUpdate) {

                <div class="message-help background" style="display: block">

                    @if(fromPremiumToStarterUpdate) {

                        <p>{{'subscription.actions.premiumToStarter.title.value' | translate : {date: birthdayDate | date : 'shortDate' : null : localeId} }}</p>

                        <div class="ck-content" [innerHTML]="'subscription.actions.premiumToStarter.features.value' | translate"></div>

                    } @else {

                        <p style="margin: 0">{{'subscription.actions.validate.info.value' | translate : {date: birthdayDate | date : 'shortDate' : null : localeId} }}</p>
                    }
                </div>
            }
        </div>
    </div>

    @if(isStarterSubscriptionSelected && offerPublicationFromChannelDisabledWarningDisplayed) {

        <div class="ligne_form row x_center">
            <div class="form-group">
            <span class="message-help background x_center">
                <mat-icon class="tooltip_icon">info</mat-icon>{{ 'subscription.offer.publication.fromChannel.disabled.description.value' | translate }}
            </span>
            </div>
        </div>
    }

    @if(!isDisabled && isSubmitAllowed && isUpgrade && !isSubscriptionWithoutOfferUpdate && (!isStarterSubscriptionSelected || !offerPublicationFromChannelDisabledWarningDisplayed)) {

        <!-- Informations relatives au paiement -->

        <div class="ligne_form row x_center">
            <div class="form-group">
            <span class="message-help background x_center">
                <mat-icon class="tooltip_icon">info</mat-icon>{{ 'subscription.payment.warning.value' | translate }}
            </span>
            </div>
        </div>
    }

    @if(!isDisabled && isSubmitAllowed && isUpgrade && !isSubscriptionWithoutOfferUpdate && !isStarterSubscriptionSelected) {

        <div class="ligne_form row x_center">
            <div class="without_payment_information">
                <p [innerHTML]="'subscription.without_card_registration.value' | translate"></p>
            </div>
        </div>
    }

    @if(!isDisabled && isSubmitAllowed) {

        <!-- Validation du formulaire -->

        <div class="ligne_form row x_center actions">

            <ng-content select="[cancelAction]"></ng-content>

            @if(!currentValidSocietySubscription && isSubscriptionWithoutOffer) {

                <!-- Validation dans le cas d'un premier abonnement sans offre -->

                <div class="col_content">
                    <button type="submit" class="btn_cta btn_little">
                        {{ 'subscription.actions.validate.value' | translate }}
                    </button>
                </div>
            }

            @if(!currentValidSocietySubscription && !isSubscriptionWithoutOffer) {

                <!-- Validation + Paiement dans le cas d'un premier abonnement avec offre -->

                <div class="col_content">
                    <button type="submit" class="btn_cta btn_little">
                        {{ 'subscription.actions.validatePayment.summary.value' | translate }}
                    </button>
                </div>
            }

            @if(isSubscriptionWithoutOfferUpdate) {

                <!-- Validation dans le cas d'un abonnement sans offre, en ayant actuellement un abonnement sans offre -->

                <div class="col_content">
                    <button type="submit" class="btn_cta btn_little">
                        {{ 'subscription.actions.validate.value' | translate }}
                    </button>
                </div>
            }

            @if(currentValidSocietySubscription && isDowngrade && !isSubscriptionWithoutOfferUpdate) {

                <!-- Validation dans le cas d'un downgrade, en ayant actuellement un abonnement -->

                <div class="col_content">
                    <button type="submit" class="btn_cta btn_little">
                        {{ 'subscription.actions.validate.value' | translate }}
                    </button>
                </div>
            }

            @if(currentValidSocietySubscription && isUpgrade && !isSubscriptionWithoutOfferUpdate) {

                <!-- Validation + Paiement dans le cas d'un upgrade, en ayant actuellement un abonnement -->

                <div class="col_content">
                    <button type="submit" class="btn_cta btn_little">
                        {{ 'subscription.actions.validatePayment.summary.value' | translate }}
                    </button>
                </div>
            }
        </div>
    }

</form>
